export const PING_WALLET_GET_DETAILS = "PING_WALLET_GET_DETAILS";
export const SET_WALLET_PING_INFO = "SET_WALLET_PING_INFO";